module.exports = __webpack_public_path__ + "img/Bouclier08.ed77bfd8.png";